export default __webpack_public_path__ + "static/media/4rest.6340c544.JPG";